import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '@src/library/hooks/common';

const initialState: { programId: number | null } = {
  programId: null,
};

export const shareProgramSlice = createSlice({
  name: 'programs/shareProgram',
  initialState: initialState,
  reducers: {
    share: (state, action: PayloadAction<{ programId: number | null }>) => {
      state.programId = action.payload.programId;
    },
  },
});

const shareAction = shareProgramSlice.actions;
export const shareProgramReducer = shareProgramSlice.reducer;

const selectShare = (state: RootState) => state.programFeatureReducers.share;

export const useProgramShare = () => {
  const dispatch = useAppDispatch();
  const shareModal = useAppSelector(selectShare);

  const toggleShareModal = (programId: number | null) => {
    dispatch(shareAction.share({ programId: programId }));
  };

  return {
    programId: shareModal.programId,
    toggleShareModal,
    isShareModalOpen: !!shareModal.programId,
  };
};
